/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'

class Drive extends Component {
    render () {
        return(
            <div className="social">
                <a href="https://drive.google.com/file/d/1pLfTKa3m0u1uCniZ3hivUasQNLTgTuwq/view?usp=sharing" target="_blank" rel="noopender noreferrer">
                <i class="fa fa-file" aria-hidden="true">  Resume Document PDF's Kongkom Sumlee
                </i>
                </a>
            </div>
        );
    }
}

export default Drive;